module.exports = require("@ember/render-modifiers/modifiers/did-insert");